//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'Modal',

	props: {
		innerClass: {
			type: String,
			required: false,
			default: '',
		},
		maxWidth: {
			type: String,
			required: false,
			default: 'sm:max-w-lg',
		},
	},

	data() {
		return {
			active: false,
		};
	},

	mounted() {
		this.active = true;

		this.$store.dispatch('updateModalOpen', true);
	},
	destroyed() {
		this.$store.dispatch('updateModalOpen', false);
	},

	methods: {
		async destroy() {
			this.active = false;
			setTimeout(() => {
				this.$emit('close');
			}, 200);
		},
	},
};
